module.exports = __webpack_public_path__ + "static/media/eco-mode.6cdbd2bc.png";